<template>
    <div>
        <hr>
        <div class="card-body" v-if="!signed">
            <div class="button-group text-center">
                <button v-if="trade.seller_id === currentUser.id && !trade.contract_ref" @click="makeContract()" class="btn btn-primary" type="button">Contract</button>
<!--                <button @click="signTrade()" class="btn btn-info" type="button">Sign</button>-->
            </div>
        </div>
<!--        <div class="card-body" v-if="signed">-->
<!--            <div class="text-center">-->
<!--                <h4><i class="fas fa-check-circle text-success"></i>&nbsp;You have signed.</h4>-->
<!--                <h4>Waiting for counterparty to sign</h4>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="card-body">-->
<!--            <p class="text-center aboutscroll">-->
<!--                Cryptographically sign this trade. After both parties sign, the contract becomes binding.-->
<!--            </p>-->
<!--        </div>-->
    </div>
</template>


<script>
    import _ from 'lodash';
    import {mapGetters} from "vuex";

    export default {
        name: "Sign",
        computed: {
            ...mapGetters(["currentUser"])
        },
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {
                signed: false
            }
        },
        beforeMount() {
            this.transitions();
        },
        methods: {
            async transitions() {
                try {
                    let reply = await this.$http.get('/trades/' + this.trade.trade_id + '/transitions');
                    this.signed = _.some(reply.data, {'status': 'SIGNED', 'transitioned_by': this.currentUser.id});
                } catch (e) {
                    console.log(e);
                }
            },
            async signTrade() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/sign', {comments: ''});
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'You have signed this trade.', 'Signed');
                    this.events.$emit('trade:reload');
                    this.transitions();
                } catch (e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Trade sign failed', 'Failed');
                }
            },
            async makeContract() {
                try {
                    let {data} = await this.$http.post(`/trades/${this.trade.trade_id}/contract`);
                    await this.$router.push({name: 'view-marketplace-contract', params: {contractid: data.contract_id}})
                } catch (e) {

                }
            }
        }
    }
</script>

<style scoped>

</style>
